var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',[_c('Navbar'),_c('HeadCards'),_c('v-space'),_c('v-row',[_c('v-col',[_c('TrackedProductsList')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }